import { Trans } from "@lingui/react/macro"
import React from "react"

import UniversalLink from "../../../../design-system/universal-link"
import {
  TREMENDOUS_APP_LOGIN,
  TREMENDOUS_APP_SIGNUP,
} from "../../../../utils/urls"
import ButtonBookDemo from "../../../button-book-demo"
import * as navLinkStyle from "../nav-link/index.module.scss"
import * as styles from "./index.module.scss"

const NavMenuSecondary = () => {
  const closeMenu = (): void => {
    const activeEl = document.activeElement
    if (activeEl instanceof HTMLElement) {
      activeEl.blur()
    }
  }

  return (
    <div className={styles.navMenuSecondary}>
      <div className={styles.loginSignupLink}>
        <UniversalLink
          className={navLinkStyle.navLink}
          to={TREMENDOUS_APP_LOGIN}
          trackingProperties={{
            buttonName: "Log in",
            buttonLocation: "nav",
            buttonPosition: "1",
          }}
        >
          <div>
            <Trans>Log in</Trans>
          </div>
        </UniversalLink>
        <div className={styles.dividerNavbar} />
        <UniversalLink
          className={navLinkStyle.navLink}
          to={TREMENDOUS_APP_SIGNUP}
          trackingProperties={{
            buttonName: "Sign up",
            buttonLocation: "nav",
            buttonPosition: "1",
          }}
        >
          <div>
            <Trans>Sign up</Trans>
          </div>
        </UniversalLink>
      </div>
      <ButtonBookDemo
        onMouseUp={closeMenu}
        href="/demo"
        size="medium"
        fullWidth
        buttonLocation="nav"
        area-current="page"
      />
    </div>
  )
}

export default NavMenuSecondary
